<div class="py-1" role="none">
    <ng-container *ngIf="source == 'company'">

        <ng-container *ngIf="company.Active">

            <a href="javascript:void(0)" (click)="syncAll.emit()"
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">
                <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                </svg>
                Sync All
            </a>

            <a href="javascript:void(0)" (click)="customersSync.emit()"
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">


                <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z">
                    </path>
                </svg>
                Sync Customers
            </a>

            <a href="javascript:void(0)" (click)="companiesSync.emit()"
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">

                <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
                </svg>

                Sync Company
            </a>

            <a href="javascript:void(0)" (click)="employeeSync.emit()"
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">


                <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z">
                    </path>
                </svg>

                Sync Employees
            </a>

            <a href="javascript:void(0)" (click)="invoicesSync.emit()"
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">
                <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
                </svg>
                Sync Invoices
            </a>

            <a href="javascript:void(0)" (click)="vendorsSync.emit()"
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">
                <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a2.25 2.25 0 0 1-.75-1.732V4.5A2.25 2.25 0 0 1 4.5 2.25h15A2.25 2.25 0 0 1 21.75 4.5v2.617a2.25 2.25 0 0 1-.75 1.732" />
                </svg>
                Sync Vendors
            </a>

            <a href="javascript:void(0)" (click)="billsSync.emit()"
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">
                <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
                </svg>
                Sync Bills
            </a>

            <a href="javascript:void(0)" (click)="servicesSync.emit()"
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    class="mr-3 h-5 w-5 text-main-primary">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" />
                </svg>

                Sync Services
            </a>

            <a href="javascript:void(0)" (click)="deAttachCompnay.emit()"
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    class="mr-3 h-5 w-5 text-main-primary">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M13.181 8.68a4.503 4.503 0 0 1 1.903 6.405m-9.768-2.782L3.56 14.06a4.5 4.5 0 0 0 6.364 6.365l3.129-3.129m5.614-5.615 1.757-1.757a4.5 4.5 0 0 0-6.364-6.365l-4.5 4.5c-.258.26-.479.541-.661.84m1.903 6.405a4.495 4.495 0 0 1-1.242-.88 4.483 4.483 0 0 1-1.062-1.683m6.587 2.345 5.907 5.907m-5.907-5.907L8.898 8.898M2.991 2.99 8.898 8.9" />
                </svg>
                DeAttach
            </a>
        </ng-container>

        <a href="javascript:void(0)" *ngIf="!company.Active" (click)="attachCompnay.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="mr-3 h-5 w-5 text-main-primary">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
            </svg>
            Attach
        </a>
    </ng-container>



    <ng-container *ngIf="source == 'invoice'">

        <a href="javascript:void(0)" (click)="sendEmai.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary text-sky-900 cursor-pointer" xmlns="http://www.w3.org/2000/svg"
                fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
            </svg>
            Send Email
        </a>

        <a *ngIf="canReceivePayment" href="javascript:void(0)" (click)="receivePayment.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
            </svg>
            Receive Payment
        </a>

        <a href="javascript:void(0)" (click)="deleteInvoice.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 cursor-pointer text-red-600/80" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
            Delete Invoice
        </a>

        <a href="javascript:void(0)" (click)="downloadPdfInvoice.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">

            <!-- <svg class="mr-3 h-5 w-5 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg> -->

            <svg class="mr-3 h-5 w-5 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path
                    d="M5 4h10v4h4v12H5zM3.999 2A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992h16.014A1 1 0 0 0 21 20.992V7l-5-5zm6.5 5.5c0 1.577-.455 3.437-1.224 5.153-.772 1.723-1.814 3.197-2.9 4.066l1.18 1.613c2.927-1.952 6.168-3.29 9.304-2.842l.457-1.939C14.644 12.661 12.5 9.99 12.5 7.5zm.6 5.972c.268-.597.505-1.216.705-1.843a9.7 9.7 0 0 0 1.706 1.966c-.982.176-1.944.465-2.875.833q.248-.471.465-.956" />
            </svg>

            Download Invoice
        </a>

        <a *ngIf="invoice?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': invoice?.pulling}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': invoice?.pushing}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>

    </ng-container>

    <ng-container *ngIf="source == 'bill'">

        <a *ngIf="bill?.Id" href="javascript:void(0)" (click)="sendEmai.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary text-sky-900 cursor-pointer" xmlns="http://www.w3.org/2000/svg"
                fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
            </svg>
            Send Email
        </a>

        <a *ngIf="canPay" href="javascript:void(0)" (click)="payBill.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
            </svg>
            Pay
        </a>

        <a href="javascript:void(0)" (click)="deleteBill.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 cursor-pointer text-red-600/80" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
            Delete Bill
        </a>

        <a *ngIf="bill?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': bill?.pulling}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': bill?.pushing}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>

    </ng-container>

    <ng-container *ngIf="source == 'billPayment'">
        <a *ngIf="billPayment?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': billPayment?.pulling}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': billPayment?.pushing}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
        <a *ngIf="billPayment?.Id" href="javascript:void(0)" (click)="voidPayment.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
            Void
        </a>
        <a href="javascript:void(0)" (click)="deleteBillPayment.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 cursor-pointer text-red-600/80" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
            Delete
        </a>
    </ng-container>

    <ng-container *ngIf="source == 'payment'">
        <a *ngIf="payment?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': payment?.pulling}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a *ngIf="!payment?.Id" href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': payment?.pushing}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
        <a *ngIf="payment?.Id" href="javascript:void(0)" (click)="voidPayment.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
            Void
        </a>
        <a href="javascript:void(0)" (click)="deletePayment.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 cursor-pointer text-red-600/80" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
            Delete
        </a>
    </ng-container>
    <ng-container *ngIf="source == 'vendor'">
        <a *ngIf="vendor?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': vendor?.pulling}" class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': vendor?.pushing}" class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
    </ng-container>

    <ng-container *ngIf="source == 'customer'">
        <a *ngIf="customer?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': customer?.pulling}" class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': customer?.pushing}" class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
    </ng-container>

    <ng-container *ngIf="source == 'service'">
        <a *ngIf="service?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': service?.pulling}" class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': service?.pushing}" class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
    </ng-container>

    <ng-container *ngIf="source == 'employee'">
        <a *ngIf="employee?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': employee?.pulling}" class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': employee?.pushing}" class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
    </ng-container>

    <ng-container *ngIf="source == 'product'">
    
        <a *ngIf="company?.Active" href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1">
            Push To
        </a>
    
        <a  href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1">
            Pull From
        </a>
    
    
    </ng-container>



</div>